import './Login.css';
import FaceControl from '../assets/login.jpeg';
import { SignUp } from './SignUp';
import React from "react";
import {NavLink} from "react-router-dom";

const Login = ({isLoadingStatus,...props}) => {
    return (
        <div className="container">
            {/*http://localhost:3000*/}
            <div className="py-1 pt-2 bg-primary top ">
                <div className="container">
                    <div className="row no-gutters d-flex align-items-start align-items-center px-md-0">
                        <div className="col-lg-12 d-block">
                            <div className="row d-flex">
                                <div className="col-md pr-4 d-flex topper align-items-center"
                                     style={{maxHeight:"25px"}}
                                >
                                    <div className="icon mr-2 d-flex justify-content-center align-items-center"><span
                                        className="icon-phone2"></span></div>
                                    <span className="text">+ 994505000000</span>
                                </div>
                                <div className="col-md pr-4 d-flex topper align-items-center"
                                     style={{maxHeight:"25px"}}
                                >
                                    <div className="icon mr-2 d-flex justify-content-center align-items-center"
                                    ><span
                                        className="icon-paper-plane"></span></div>
                                    <span className="text">youremail@email.com</span>
                                </div>
                                <div
                                    className="col-md-5 pr-4 d-flex topper align-items-center text-lg-right justify-content-end"
                                    style={{maxHeight:"25px"}}
                                >
                                    <p className="mb-0 register-link ">
                                        {/*<a href="/#" className="mr-3">Sign Up</a>*/}
                                        {/*<NavLink to={'/'}*/}
                                        {/*         onClick={()=>{*/}

                                        {/*         }}*/}
                                        {/*         className="brand-link">Ana Səhifə</NavLink>*/}
                                        <NavLink
                                            // to={'/login'}
                                            to={{pathname:"https://medicschool.az"}}
                                            // to={{pathname:"http://localhost:3000"}}
                                            target="_parent"

                                            // onClick={()=>{
                                            //     setLoginPageLoaded(true)
                                            // }}
                                            className="brand-link text-light">Ana Səhifə</NavLink>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={`center`} >
                <div className="row">
                    <div className="col-md-7 col-12 mt-3 my-auto">
                        <img className="img-fluid w-100" src={FaceControl} alt=""/>
                    </div>
                    <div className="col-md-5 col-12">
                        <SignUp {...props}/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
